
import CompetitionStatsGenerator from '@/components/CompetitionStatsGenerator.component.vue'

export default {
  name: 'CompetitionStatistics',
  components: {
    CompetitionStatsGenerator
  },
  props: {
    competitionId: {
      type: String,
      required: true
    },
    competition: {
      type: Object,
      default: function (): any {
        return {}
      }
    }
  },
  computed: {
    competitionName (): string {
      return (this.competition && this.competition.name) || 'Competition'
    }
  }
}
